import { useTranslations } from '@vocab/react';
import { Button } from 'braid-design-system';
import React, { type FunctionComponent, type MouseEvent } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { PREVIEW_OPENED_EVENTDATA } from 'src/app/analytics/preview';
import getTrackingAdapter from 'src/app/dataAnalytics';
import { JOB_PREVIEW_PRESSED } from 'src/app/dataAnalytics/schema/constants';
import {
  FEATURE_DATA_ANALYTICS,
  useFeatureToggleData,
} from 'src/app/featureToggle';
import { actionUpdateIsPreviewOpen } from 'src/app/state/modules/app/isPreviewOpen';
import { sendLinkEvent } from 'src/app/utils/analytics';
import type AppState from 'src/types/appState';

import translations from './.vocab';

export const PreviewButton: FunctionComponent = () => {
  const { isPaymentInProgress, tealium } = useSelector(
    (state: AppState) => ({
      tealium: state.tealium,
      isPaymentInProgress: state.session.isPaymentInProgress,
    }),
    shallowEqual,
  );

  const isPageAnalyticsEnabled = useFeatureToggleData(FEATURE_DATA_ANALYTICS);

  const dispatch = useDispatch();

  const { t } = useTranslations(translations);

  const handlePreviewClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (isPaymentInProgress) {
      return;
    }

    event.preventDefault();
    dispatch(actionUpdateIsPreviewOpen(true));
    if (isPageAnalyticsEnabled) {
      const eventData = {
        eventName: JOB_PREVIEW_PRESSED,
        objectInteraction: 'job-ad-preview',
        actionOrigin: 'job-ad-preview',
      };
      getTrackingAdapter.sendLinkEvent(eventData);
    } else {
      sendLinkEvent(tealium, PREVIEW_OPENED_EVENTDATA);
    }
  };

  return (
    <Button type="button" variant="ghost" onClick={handlePreviewClick}>
      {t('preview-button-text')}
    </Button>
  );
};
